module.exports = __webpack_public_path__ + "static/media/Impreza-Hawk-GD-Sedan-WRX-STi.74347959.webp";